module.exports = __webpack_public_path__ + "officialStatic/img/case3.2c0685d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case3.png
// module id = uq4d
// module chunks = 0